module.exports = __webpack_public_path__ + "img/t4-3.a383f6cb.svg";